import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const ITConsulting = () => {

  const projects = [
    {
      title: "Startup Consulting",
      desc: "Helped startups choose the right tech stack.",
      link: "#",
    },
  ];

  const testimonials = [
    {
      name: "Bilal Khan",
      role: "CEO",
      feedback: "Saved us from costly mistakes.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-yellow-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Expert <span className="text-yellow-400">IT Consulting</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Make smarter technology decisions and scale with confidence.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-yellow-500 rounded-full">
              Get Consultation
            </Link>

            <a href="https://calendly.com/thelogicwaves/30min"
              className="px-8 py-4 border rounded-full">
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* WHAT WE DO */}
      <section className="py-24 px-6 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {[
          "Tech Strategy",
          "Architecture Planning",
          "Startup Guidance",
          "Digital Transformation",
          "Performance Optimization",
          "Tech Stack Selection",
        ].map((item, i) => (
          <div key={i} className="bg-white/5 p-6 rounded-xl">
            <h3 className="text-yellow-400">{item}</h3>
          </div>
        ))}
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-yellow-500 to-orange-500">
        <h2 className="text-4xl font-bold mb-6">
          Get Expert Guidance 🚀
        </h2>
        <Link to="/contact" className="bg-black px-6 py-3 rounded">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default ITConsulting;